/**
 * ReportsStatsCell - Display active matters count
 */

interface ReportsStatsCellProps {
  activeMatters: number;
}

export const ReportsStatsCell = ({ activeMatters }: ReportsStatsCellProps) => {
  if (activeMatters === 0) {
    return <span className="text-sm text-gray-400">—</span>;
  }

  return (
    <span className="text-sm font-medium text-gray-900">{activeMatters}</span>
  );
};
